// extracted by mini-css-extract-plugin
export default {"galerie":"SpectacleDetailGallery_galerie__GtxuN"};